import React from 'react';
import soupyLogo from '../../../../static/claromentis-ds-logo@2x.png'

const Logo = () => <img src={soupyLogo} alt="soupy-logo" style={{ width: 160 }} />

export default Logo;
